import { render } from "./shareTrend.vue?vue&type=template&id=47fc50be&scoped=true"
import script from "./shareTrend.vue?vue&type=script&lang=js"
export * from "./shareTrend.vue?vue&type=script&lang=js"

import "./shareTrend.vue?vue&type=style&index=0&id=47fc50be&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47fc50be"]])

export default __exports__